import {ChangeDetectionStrategy, Component, HostBinding} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-spanning-fixture",
    styleUrls: ["./spanning-fixture.component.scss"],
    templateUrl: "./spanning-fixture.component.html",
    standalone: false
})
export class FUISpanningFixtureComponent {
    @HostBinding("class.active") public active: boolean;

    constructor() {
        this.active = true;
    }
}
